import {
  Autocomplete,
  Button,
  Drawer,
  IconButton,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useBranchActions } from 'src/context/providers/BranchContext';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';
import { useCountryData } from 'src/context/providers/CountryContext';
import InputFieds from '../../custom_components/Froms/InputFields';
import { status, personalInformation } from './view/data';

const CreateBranchDrawer = ({ isDrawerOpen, handleDrawerToggle }) => {
  const [branchData, setBranchData] = useState({
    name: '',
    address: '',
    postalCode: '',
    city: '',
    country: '',
    phone: '',
    status: '',
  });
  const { createBranch } = useBranchActions();
  const [country, setCountry] = useState({
    id: '',
    name: '',
  });
  const Clear = () => {
    setBranchData({
      name: '',
      address: '',
      postalCode: '',
      city: '',
      country: '',
      phone: '',
    });
    setCountry({ id: '', name: '' });
  };

  const tableData = useCountryData();

  const handleCreateBranch = async () => {
    const branchData1 = {
      name: branchData.name,
      address: branchData.address,
      postalCode: branchData.postalCode,
      state: branchData.state,
      phone: branchData.phone,
      status: branchData.status,
      country_id: country.id,
    };
    await createBranch(branchData1);
    Clear();
    handleDrawerToggle();
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setBranchData({
      ...branchData,
      [name]: value,
    });
  };

  const DrawerConfig = {
    SubNavigation: true,
    anchor: 'right',
    width: '40%',
    drawerHeaderText: 'Create Branch',
    buttons: {
      status: true,
      elements: [{ name: 'Create', onClick: handleCreateBranch }],
    },
  };

  const containerStyle = {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
    position: 'fixed',
    zIndex: 2,
    top: 0,
    left: 0,
    display: isDrawerOpen ? 'block' : 'none',
    cursor: 'pointer',
  };

  const handleOutsideClick = (event) => {
    if (event.target === event.currentTarget) {
      handleDrawerToggle();
      Clear();
    }
  };

  return (
    <div
      role="button"
      tabIndex={0}
      style={containerStyle}
      onKeyDown={(event) => {
        if (event.key === 'Escape') {
          handleDrawerToggle();
        }
      }}
      onClick={handleOutsideClick}
    >
      <Drawer
        variant="persistent"
        anchor={DrawerConfig.anchor}
        open={isDrawerOpen}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: { width: { lg: DrawerConfig.width, xs: '100%', md: '100%' } },
        }}
      >
        {/* Drawer Content */}

        {/* Header */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '16px',
            borderBottom: '1px solid rgba(220, 220, 220, 0.2)',
          }}
        >
          <Typography variant="h6">{DrawerConfig.drawerHeaderText}</Typography>
          <div
            style={{
              width: '30%',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <TextField
              name="status"
              label="status"
              value={branchData[status]}
              onChange={handleInputChange}
              variant="filled"
              sx={{ minWidth: '80%' }}
              select
            >
              {status.map((i, index) => (
                <MenuItem key={index} value={i}>
                  {i}
                </MenuItem>
              ))}
            </TextField>

            <IconButton onClick={handleDrawerToggle}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* Form */}
        <div
          className="content-wrap"
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '2px',
            padding: '30px 0px 0px 0px',
            alignItems: 'center',
            justifyContent: 'space-evenly',
          }}
        >
          {/* Form */}

          {/* Personal Information */}
          <InputFieds
            userData={branchData}
            heading="Branch Information"
            inputFields={personalInformation}
            setUserData={setBranchData}
          />
          {/* <div
            className="content-wrap"
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              width: '100%',
              padding: '0px 0px 0px 20px',
            }}
          >
            <ComboBox
              nameOfInput="city"
              data={cityArray}
              setter={handleInputChange}
              value={branchData.city}
            />
          </div> */}
          {/* Personal Information */}
        </div>
        <div
          className="content-wrap"
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            width: '95%',
            padding: '0px 0px 0px 20px',
          }}
        >
          <Autocomplete
            sx={{ width: '100%' }}
            options={tableData}
            getOptionLabel={(option) => option.name || ''}
            value={country}
            onChange={(event, newValue) => setCountry(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Box Tracking"
                variant="filled"
                InputProps={{
                  ...params.InputProps,
                }}
              />
            )}
          />
        </div>

        {/* Buttons */}
        {DrawerConfig.buttons && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              borderTop: '1px solid rgba(220, 220, 220, 0.2)',
              padding: '16px',
              position: 'absolute',
              bottom: '0',
              left: '0',
              width: '100%',
            }}
          >
            {DrawerConfig.buttons.elements.map((element) => (
              <Button
                variant="contained"
                style={{
                  marginLeft: '24px',
                  width: '136px',
                }}
                onClick={element.onClick}
              >
                Create
              </Button>
            ))}
          </div>
        )}
      </Drawer>
    </div>
  );
};

CreateBranchDrawer.propTypes = {
  isDrawerOpen: PropTypes.bool.isRequired,
  handleDrawerToggle: PropTypes.func.isRequired,
};

export default CreateBranchDrawer;
